import * as React from 'react';
import { Logo, Loader, Card } from '@grandvisionhq/common';
import { Heading, Divider } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { ErrorPage } from '@grandvisionhq/layout';
import { useIntl } from '@grandvisionhq/state';
import { OrderConfirmDeliveryIndicatorContainer } from './components/OrderConfirmDeliveryIndicator/OrderConfirmDeliveryIndicatorContainer.js';
import { OrderLineItemsSummaryContainer } from './components/OrderLineItemsSummary/OrderLineItemsSummaryContainer.js';
import { LineItemsContainer } from './container/LineItemContainer.js';
import { OrderConfirmHeroBanner } from './components/OrderConfirmHeroBanner/OrderConfirmHeroBanner.js';
import { OrderDetailsSummary } from './components/OrderDetailsSummary/OrderDetailsSummary.js';
import { OrderPaymentSummary } from './components/OrderPaymentSummary/OrderPaymentSummary.js';

const OrderConfirm = ({ order , logo , labels , contains , isLoading , error ,  })=>{
    const { getLabel  } = useIntl();
    const link = useLink({
        route: 'home'
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm"
    }, /*#__PURE__*/ React.createElement("header", {
        className: "orderConfirm__header"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__logo"
    }, logo && /*#__PURE__*/ React.createElement(Logo, {
        url: "/",
        image: logo
    }))), error && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ErrorPage, {
        header: getLabel('common.pageNotFound.header'),
        subheader: getLabel('common.pageNotFound.subheader'),
        buttonText: getLabel('cart.actions.goBack'),
        buttonHref: link === null || link === void 0 ? void 0 : link.href
    })), !order && isLoading && /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__loading"
    }, /*#__PURE__*/ React.createElement(Loader, null)), order && !isLoading && /*#__PURE__*/ React.createElement("main", {
        className: "orderConfirm__main"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__hero"
    }, /*#__PURE__*/ React.createElement(OrderConfirmHeroBanner, {
        orderNumber: order.orderNumber,
        labels: labels,
        contains: contains
    })), /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__detailsContainer"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__summaries"
    }, /*#__PURE__*/ React.createElement(OrderDetailsSummary, {
        labels: labels,
        orderData: order
    })), /*#__PURE__*/ React.createElement("div", {
        className: "orderConfirm__lineItem"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.orderDetailsHeader), /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(OrderConfirmDeliveryIndicatorContainer, {
        lineItems: order.lineItems
    })), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(LineItemsContainer, {
        lineItems: order === null || order === void 0 ? void 0 : order.lineItems
    })), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(OrderPaymentSummary, {
        paymentMethod: order.paymentMethod,
        paymentDetails: order.paymentDetails
    })), /*#__PURE__*/ React.createElement(Divider, null), /*#__PURE__*/ React.createElement(Card.Section, null, /*#__PURE__*/ React.createElement(OrderLineItemsSummaryContainer, {
        order: order
    }))))))));
};

export { OrderConfirm };
//# sourceMappingURL=OrderConfirm.js.map
